/**
 * The DCC (adib-frontend) app: one place that knows where it lives.
 *
 * Both frontends run against the same backend and the same session cookie, so this app
 * links out to the DCC in two situations — a signed-out user going back to its login
 * screen (see ./dccLogin), and the ORM sidebar entry jumping to its dashboard. Both must
 * resolve the same origin, hence this module rather than a second copy of the env read.
 *
 * REACT_APP_URL_DCC is the origin only, e.g. http://localhost:5050 — no trailing slash,
 * no path. Note CRA inlines REACT_APP_* at BUILD time and reads .env only at dev-server
 * startup, so the fallback below is what a not-yet-restarted server actually uses; keep
 * the two in step.
 */
const DEFAULT_DCC_ORIGIN = 'https://demo.pianat.ai';

export const DCC_ORIGIN = String(
  process.env.REACT_APP_URL_DCC || DEFAULT_DCC_ORIGIN,
).replace(/\/+$/, '');

/**
 * Build an absolute DCC URL.
 *
 * @param path root-relative path, with or without the leading slash ('/' for the home
 *             dashboard, which is the DCC's ORM landing screen).
 */
export function dccUrl(path = '/'): string {
  const suffix = path.startsWith('/') ? path : `/${path}`;
  return `${DCC_ORIGIN}${suffix}`;
}

/** The DCC ORM dashboard — the DCC home, which is where RCM/Risks/Controls/KRIs live. */
export const DCC_ORM_URL = dccUrl('/');
